<template>
  <div class="contai_h">
    <div class="cont_tabs">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="cont_tab">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>复核订单</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="cont_ta">
      <el-tabs type="border-card" @tab-click="tabClick">
        <!-- 建当复核 -->
        <el-tab-pane label="建当订单复核">
          <el-table :data="items" border style="width: 100%">
            <el-table-column label="操作" width="150">
              <template slot-scope="scope">
                <el-button @click="handle(scope.row)" type="text" size="small"
                  >复核</el-button
                >

                <el-button @click="handleClick(scope.row._id)" type="text" size="small"
                  >查看</el-button
                >
                <el-button @click="delClick(scope.row._id)" type="text" size="small"
                  >删除</el-button
                >
              </template>
            </el-table-column>
            <el-table-column prop="deta" label="建当日期" width="160"> </el-table-column>
            <el-table-column prop="ticketnumber" label="票号" width="120">
            </el-table-column>
            <el-table-column prop="name" label="姓名" width="100"> </el-table-column>
            <el-table-column prop="telnumber" label="电话" width="150"> </el-table-column>
            <!-- <el-table-column prop="address" label="当户证件地址" width="250">
            </el-table-column> -->
            <el-table-column prop="itemname" label="物品类型" width="90">
            </el-table-column>
            <el-table-column prop="objname" label="物品名称" width="120">
            </el-table-column>
            <el-table-column prop="speci" label="规格/状况" width="120">
            </el-table-column>
            <el-table-column prop="number" label="数量" width="70"> </el-table-column>
            <el-table-column prop="weight" label="重量/g" width="120"> </el-table-column>
            <el-table-column prop="price" label="典当金额" width="120"> </el-table-column>
            <el-table-column prop="startdate" label="开始日期" width="120">
            </el-table-column>
            <el-table-column prop="enddate" label="结束日期" width="120">
            </el-table-column>
            <!-- <el-table-column prop="mode" label="支付方式" width="100"> </el-table-column> -->
            <el-table-column prop="cost" label="典当综合费/元" width="120">
            </el-table-column>
            <el-table-column prop="days" label="典当天数/天" width="120">
            </el-table-column>
            <el-table-column prop="agent" label="经办人" width="120"> </el-table-column>
          </el-table>
        </el-tab-pane>

        <!-- 断当回收 -->
        <el-tab-pane label="断当回收订单复核">
          <el-table :data="recove" border style="width: 100%">
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button @click="reco(scope.row._id)" type="text" size="small"
                  >复核</el-button
                >
              </template>
            </el-table-column>
            <el-table-column prop="input_pnum" label="票号" width="130"></el-table-column>
            <el-table-column prop="deta" label="回收日期" width="160"></el-table-column>
            <el-table-column prop="input_names" label="姓名" width="100">
            </el-table-column>
            <el-table-column prop="input_wus" label="物品类型" width="120">
            </el-table-column>
            <el-table-column prop="tabs_inputs" label="物品名称" width="150">
            </el-table-column>
            <el-table-column prop="tabs_inpus" label="规格/状况" width="100">
            </el-table-column>
            <el-table-column prop="tabs_inps" label="数量" width="80"></el-table-column>
            <el-table-column prop="tabs_ins" label="重量/g" width="100">
            </el-table-column>
            <el-table-column prop="tabs_is" label="回收金额" width="100">
            </el-table-column>
            <el-table-column prop="inputzf" label="备注" width="170"> </el-table-column>
            <el-table-column prop="radios" label="证件类型" width="120">
            </el-table-column>
            <el-table-column prop="input_tels" label="电话" width="180">
            </el-table-column>
            <el-table-column prop="input_idcards" label="证件号码" width="250">
            </el-table-column>
            <el-table-column prop="input_adds" label="当户证件地址" width="250">
            </el-table-column>
            <el-table-column prop="agent" label="经办人" width="100"></el-table-column>
          </el-table>
        </el-tab-pane>

        <!-- 鉴定评估复核 -->
        <el-tab-pane label="鉴定评估订单复核">
          <el-table :data="assment" border style="width: 100%">
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button @click="asses(scope.row._id)" type="text" size="small"
                  >复核</el-button
                >
              </template>
            </el-table-column>
            <el-table-column prop="deta" label="鉴定日期" width="160"> </el-table-column>
            <el-table-column prop="name" label="姓名" width="120"> </el-table-column>
            <el-table-column prop="radio" label="证件类型" width="120"> </el-table-column>
            <!-- <el-table-column prop="input_idcard" label="证件号码" width="250">
            </el-table-column> -->
            <el-table-column prop="input_tel" label="电话" width="200"> </el-table-column>
            <!-- <el-table-column prop="adds" label="当户证件地址" width="260">
            </el-table-column> -->
            <el-table-column prop="input_wu" label="物品名称" width="150">
            </el-table-column>
            <el-table-column prop="tabs_inpus" label="规格" width="100">
            </el-table-column>
            <el-table-column prop="tabs_inps" label="数量" width="100"> </el-table-column>
            <el-table-column prop="tabs_ins" label="重量/g" width="120">
            </el-table-column>
            <el-table-column prop="tabs_is" label="鉴定备注" width="120">
            </el-table-column>
            <el-table-column prop="inputjd" label="已收鉴定费" width="120">
            </el-table-column>
            <el-table-column prop="agent" label="经办人" width="120"> </el-table-column>
          </el-table>
        </el-tab-pane>

        <!-- 业务恢复复核 -->
        <el-tab-pane label="恢复业务复核">
          <el-table :data="recoverData" border style="width: 100%">
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button @click="ReviewConfirm(scope.row)" type="text" size="small"
                  >确定恢复</el-button
                >
              </template>
            </el-table-column>
            <el-table-column prop="CreateDate" label="申请日期" width="160">
            </el-table-column>
            <el-table-column prop="TicketNumber" label="申请票号" width="120">
            </el-table-column>
            <el-table-column prop="username" label="当户" width="120"> </el-table-column>
            <el-table-column prop="xuname" label="申请人" width="120"> </el-table-column>
            <el-table-column prop="overdate" label="申请开始/日期" width="200">
            </el-table-column>
            <el-table-column prop="xuDate" label="申请到期/日期" width="200">
            </el-table-column>
            <el-table-column prop="xuday" label="申请续当/天" width="150">
            </el-table-column>
            <el-table-column prop="yuDate" label="逾期天数/天" width="150">
            </el-table-column>
            <el-table-column prop="xupri" label="典当综合费" width="150">
            </el-table-column>
            <el-table-column prop="xulx" label="利息" width="150"> </el-table-column>
          </el-table>
        </el-tab-pane>

        <!-- 历史恢复业务 -->
        <el-tab-pane label="历史恢复业务">
          <el-table :data="recoverDataList" border style="width: 100%">
            <el-table-column prop="CreateDate" label="申请日期" width="160">
            </el-table-column>
            <el-table-column prop="TicketNumber" label="申请票号" width="120">
            </el-table-column>
            <el-table-column prop="username" label="当户" width="120"> </el-table-column>
            <el-table-column prop="xuname" label="申请人" width="120"> </el-table-column>
            <el-table-column prop="reviewNane" label="复核" width="120">
            </el-table-column>
            <el-table-column prop="overdate" label="申请开始/日期" width="200">
            </el-table-column>
            <el-table-column prop="xuDate" label="申请到期/日期" width="200">
            </el-table-column>
            <el-table-column prop="xuday" label="申请续当/天" width="150">
            </el-table-column>
            <el-table-column prop="yuDate" label="逾期天数/天" width="150">
            </el-table-column>
            <el-table-column prop="xupri" label="典当综合费" width="150">
            </el-table-column>
            <el-table-column prop="xulx" label="利息" width="150"> </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
export default {
  name: "review",

  data() {
    return {
      ACCESS_TOKEN: "", //get请求的ACCESS_TOKEN密钥
      items: [], //接收建档的数据
      recove: [], //接收收回的数据
      assment: [], //接收鉴定评估的数据
      recoverData: [], //请求要恢复的业务数据
      recoverDataList: [], //历史恢复数据
      username: "", //当前登录的用户名
    };
  },
  methods: {
    handle(event) {
      // if
      if (event.startdate < dayjs().format("YYYY-MM-DD")) {
        // 典当开始日期小于今天的日期
        if (
          this.userData.tokenId == "caddGl002" ||
          this.userData.tokenId == "caddGl016"
        ) {
          //如果是管理员账号或者陈伟均账号
          let fid = event._id;
          this.$router.push({ path: "/revs", query: { id: fid } });
        } else {
          this.$alert("补录以往业务请联系 陈伟均 或 管理员 进行复核", "温馨提示", {
            confirmButtonText: "确定",
          });
        }
      } else {
        //典当开始日期大于或等于今天的日期
        let fid = event._id;
        this.$router.push({ path: "/revs", query: { id: fid } });
      }
    },
    handleClick(e) {
      let id = e;
      this.$router.push({ path: "/details", query: { id: id } });
    },
    //删除
    delClick(eid) {
      this.$confirm("此操作将删除该条信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post("/api/tcb/databasedelete?access_token=" + this.ACCESS_TOKEN, {
              env: `${this.userData.env}`,
              query: `db.collection("add_data").doc("${eid}").remove()`,
            })
            .then((r) => {
              if (r.data.errmsg == "ok") {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                this.$router.go(0);
              } else {
                this.$message.error("删除失败，请刷新页面在试试");
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    reco(e) {
      let sid = e;
      this.$router.push({ path: "/take", query: { id: sid } });
    },
    asses(e) {
      let jid = e;
      this.$router.push({ path: "/appraisal", query: { id: jid } });
    },
    // 建当订单数据
    jiand() {
      //建当订单数据
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("add_data").where({review:_.eq(""),reviewdate:_.eq("")}).limit(1000).get()`,
        })
        .then((rs) => {
          if (rs.data.errcode === 0) {
            rs.data.data.forEach((element, index, array) => {
              array[index] = JSON.parse(element);
            });
            this.items = rs.data.data;
          } else {
            this.$notify.error({
              title: "错误提示",
              message: "密钥过期啦，请刷新页面",
            });
          }
        });
      // }else{

      // }
    },
    //回收订单
    recov() {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("take_back").where({review:""}).limit(1000).get()`,
        })
        .then((rz) => {
          rz.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          this.recove = rz.data.data;
        });
    },

    //鉴定评估
    assments() {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("ass_ment").where({whether:false}).limit(1000).get()`,
        })
        .then((rj) => {
          rj.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          this.assment = rj.data.data;
          // console.log(this.assment);
        });
    },

    //切换tab栏事件
    tabClick(event) {
      if (event.index == 3) {
        this.axios
          .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query: `db.collection("recoverData").where({Isreview:false}).limit(1000).get()`,
          })
          .then((res) => {
            res.data.data.forEach((element, index, array) => {
              array[index] = JSON.parse(element);
            });
            this.recoverData = res.data.data;
          });
      } else if (event.index == 4) {
        this.axios
          .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query: `db.collection("recoverData").where({Isreview:true}).limit(1000).get()`,
          })
          .then((res) => {
            res.data.data.forEach((element, index, array) => {
              array[index] = JSON.parse(element);
            });
            this.recoverDataList = res.data.data;
          });
      }
    },
    //确定恢复
    ReviewConfirm(event) {
      this.$confirm("确定恢复该业务吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
              env: `${this.userData.env}`,
              query: `db.collection("recoverData").doc("${event._id}").update({data:{Isreview:true,reviewNane:"${this.username}"}})`,
            })
            .then((res) => {
              if (res.data.errcode == 0) {
                this.UpdateData(event.uid, event.xuDate, event);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    //修改业务的到期日期
    UpdateData(event, date, newData) {
      this.axios
        .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("add_data").doc("${event}").update({data:{enddate:"${date}"}})`,
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            this.addData(newData);
          }
        });
    },
    //添加流水
    addData(event) {
      this.axios
        .post("/api/tcb/databaseadd?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("yxus_record").add({data:{
            stas:"续当",
            ticketnumber:"${event.TicketNumber}",
            name:"${event.username}",
            itemname:"${event.itemname}",
            weight:"${event.weight}",
            xuday:"${dayjs().format("YYYY-MM-DD")}",
            overdate:"${event.overdate}",
            enddate:"${event.xuDate}",
            dday:"${event.xuday}",
            pri:"${event.price}",
            xupri:"${event.xupri}",
            lx:"${event.xulx}",
            ytdy:"${event.yuDate}",
            pena:"0",
            yspri:"${Number(event.xupri) + Number(event.xulx)}",
            rece:"${Number(event.xupri) + Number(event.xulx)}",
            couqons:"未选择优惠券",
            couqonmoney:"0",
            xuname:"${event.xuname}"
          }})`,
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            this.$notify({
              title: "业务恢复成功",
              message: "该业务已经成功恢复续当",
              type: "success",
            });

            setTimeout(() => {
              this.$router.go(0);
            }, 2000);
          }
        });
    },
  },
  created() {
    //获取到this.ACCESS_TOKEN
    this.getTokens();

    //获取当前登录的用户数据
    this.getUserToken();
    //
  },
  mounted() {
    // this.ACCESS_TOKEN = localStorage.getItem("ACCESS_TOKEN");
    setTimeout(() => {
      //请求建当订单
      this.jiand();
      //请求收回的订单
      this.recov();
      // //请求鉴定评估的订单
      this.assments();

      //当前登录的用户
      this.username = this.userData.username;
    }, 800);
  },
};
</script>
<style scoped>
.cont_tabs {
  width: 100%;
  height: 40px;
  background-color: #ffffff;
  border-radius: 10px;
  /* margin: 0 15px; */
}
.cont_tab {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0 20px;
  padding: 10px 0;
}
.cont_ta {
  width: 100%;
  height: 500px;
  background-color: #ffffff;
  border-radius: 10px;
  margin: 15px 0;
}
</style>
